export const jitsiConfig = {
  startWithAudioMuted: false,
  startWithVideoMuted: false,
  prejoinPageEnabled: false,
  disableModeratorIndicator: true,
  enableWelcomePage: false,
  enableClosePage: false,
  disableProfile: true,
  lobby: {
    autoKnock: true,
    enableChat: false,
  },
  toolbarButtons: [
    "microphone",
    "camera",
    "closedcaptions",
    "desktop",
    "fullscreen",
    "fodeviceselection",
    "hangup",
    "profile",
    "chat",
    "livestreaming",
    "etherpad",
    "sharedvideo",
    "settings",
    "raisehand",
    "videoquality",
    "filmstrip",
    "feedback",
    "stats",
    "shortcuts",
    "tileview",
    "select-background",
    "download",
    "help",
    "mute-everyone",
    "participants-pane",
  ],
};

export const jitsiInterfaceConfig = {
  TOOLBAR_ALWAYS_VISIBLE: true,
  SHOW_JITSI_WATERMARK: false,
  SHOW_WATERMARK_FOR_GUESTS: false,
  DISPLAY_WELCOME_PAGE_CONTENT: false,
  DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT: false,
  SHOW_CHROME_EXTENSION_BANNER: false,
};
